import ElementContent from '@/components/sections/builder/elements/body/image-gallery/content';
import Image from '@/components/sections/builder/elements/body/image-gallery/image';
import ElementSetting from '@/components/sections/builder/elements/body/image-gallery/setting';
import { ImageGalleryElementDataType } from '@/components/sections/builder/elements/body/image-gallery/type';
import { Images } from 'lucide-react';

const defaultData: ImageGalleryElementDataType = {
  name: 'Image Gallery',
  contentAlign: 'center',
  headingLabel: 'Gallery',
  headingSize: 'small',
  textLabel: '',
  textStyle: 'body',
  layout: 'masonry',
  size: 'small',
  totalCol: 4,
  imageRatio: 'aspect-[16/9]',
  padding: {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
};

export const ElementPreviewIcon = Images;

const defaultImages = [
  'https://placehold.co/300x400?text=Image temporary 1',
  'https://placehold.co/300x300?text=Image temporary 2',
  'https://placehold.co/400x300?text=Image temporary 3',
  'https://placehold.co/400x300?text=Image temporary 4',
  'https://placehold.co/300x300?text=Image temporary 5',
  'https://placehold.co/300x400?text=Image temporary 6',
  'https://placehold.co/300x400?text=Image temporary 7',
  'https://placehold.co/300x300?text=Image temporary 8',
  'https://placehold.co/400x300?text=Image temporary 9',
  'https://placehold.co/400x300?text=Image temporary 10',
  'https://placehold.co/300x300?text=Image temporary 11',
  'https://placehold.co/300x400?text=Image temporary 12',
];

const ImageGallery = {
  type: 'image_gallery',
  group: 'body',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  defaultChilds: defaultImages.map((img) => ({
    ...Image,
    defaultData: { ...Image.defaultData, img },
  })),
  childs: [Image],
};

export default ImageGallery;
